import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useFruits from '../../../Hooks/useFruit';
import Fruit from '../Fruit/Fruit';
import './Allinventory.css';

const Allinventory = () => {
	const [fruits, setFruit] = useFruits();

	useEffect(() => {
		fetch('https://safe-hamlet-12951.herokuapp.com/allinventory')
			.then(res => res.json())
			.then(data => setFruit(data));
	}, [])

	let navigate = useNavigate();
	const navigateTomanageFruit = (id) => {
		navigate(`/inventory/${id}`);
	}


	const handleRemoveFruit = (id) => {
		console.log(id);
		const url = `https://safe-hamlet-12951.herokuapp.com/allinventory/${id}`;
		fetch(url, {
			method: 'DELETE',
		})
			.then(res => res.json())
			.then(data => {
				console.log(data);
				if (data.deletedCount > 0) {
					const remaining = fruits.filter(fruit => fruit._id !== id);
					setFruit(remaining);
				}

			})
	}
	return (
		<div>

			<section id='inventory' className='container'>
				<h1 className='section-title'> Inventory  </h1>
				<div className="fruits-container section-center">

					{
						fruits.map(fruit => <div key={fruit._id}>

							<div className='single-item'>
								<div className="img-container">
									<img src={fruit.img} alt="" />
								</div>
								<article className='item-info'>
									<div className="fruit-info-header">
										<div className="name-price">
											<h4 className="fruit-name">{fruit.name}</h4>
											<p className='fruit-price'> Price : {fruit.price}</p>
										</div>
										<div className="quantity-supplier">
											<p> Supplier : {fruit.supplier} </p>
											<p>Quantity : {fruit.quantity} kg </p>
										</div>

									</div>
									<div className="fruit-description">
										<p>
											{fruit.description}
										</p>
									</div>
									<div className="fruit-footer">
										<p>
											<button className='fruit-btn' onClick={() => navigateTomanageFruit(fruit._id)}>Manage {fruit.name} </button>
										</p>
										<p>
											<button className="fruit-btn-one" onClick={() => handleRemoveFruit(fruit._id)}>Remove  </button>
										</p>
									</div>
								</article>
							</div>


						</div>)
					}














				</div>
				<Link to='/addfruit' className='add-fruit-btn'> Add A New Fruit </Link>
			</section>
		</div>
	);
};

export default Allinventory;
